<div class="data-wrapper" *ngIf="user$ | async as user">
    <div class="view-mode" [ngClass]="!isEditMode ? 'show' : 'hide'">
        <section class="background-color-nearwhite">
            <div class="container">
                <h1 class="top-part" [innerHTML]="'personalData.titleTop' | translate"></h1>
                <div class="personal-data-wrapper">
                    <div class="data-group username">
                        <div class="group">
                            <label class="title"><span [innerHTML]="'personalData.email' | translate"></span>:</label>
                            <label class="text">{{ user.email }} </label>
                        </div>
                    </div>
                    <div class="data-group password" *ngIf="_$showChangePassword | async">
                        <label class="title" [innerHTML]="'personalData.password' | translate"></label>
                        <div>
                            <a class="change-password" [routerLink]="linkChangePassword" da-link
                                ><span [innerHTML]="'personalData.resetPassword' | translate"></span
                            ></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="background-color-white">
            <div class="container">
                <h1 [innerHTML]="'personalData.titleView' | translate"></h1>
                <p class="large" [innerHTML]="'personalData.introView' | translate"></p>

                <div class="personal-data-wrapper">
                    <div class="top">
                        <div class="data-group">
                            <div class="group">
                                <label class="title"><span [innerHTML]="'personalData.salutation' | translate"></span>:</label>
                                <label class="text">{{ user.salutation.name }}</label>
                            </div>
                        </div>

                        <div class="data-group">
                            <div class="group">
                                <label class="title"><span [innerHTML]="'personalData.title' | translate"></span>:</label>
                                <label class="text">{{ user.title }}</label>
                            </div>
                        </div>

                        <div class="data-group">
                            <div class="group">
                                <label class="title"><span [innerHTML]="'personalData.name' | translate"></span>:</label>
                                <label class="text">{{ user.firstName }} {{ user.lastName }}</label>
                            </div>
                        </div>

                        <div class="data-group">
                            <div class="group">
                                <label class="title"><span [innerHTML]="'personalData.phone' | translate"></span>:</label>
                                <label class="text">{{ user.phoneCountry }}{{ user.phoneCity }}{{ user.phoneNumber }}</label>
                            </div>
                        </div>

                        <div class="data-group">
                            <div class="group">
                                <label class="title"><span [innerHTML]="'personalData.department' | translate"></span>:</label>
                                <label class="text">{{ user.department }}</label>
                            </div>
                        </div>
                    </div>

                    <div class="top">
                        <div class="data-group">
                            <div class="group">
                                <label class="title"><span [innerHTML]="'personalData.company' | translate"></span>:</label>
                                <label class="text">{{ user.company.name }}</label>
                            </div>
                        </div>

                        <div class="data-group">
                            <div class="group">
                                <label class="title"><span [innerHTML]="'personalData.address' | translate"></span>:</label>
                                <label class="text">{{ user.address }}</label>
                            </div>
                        </div>

                        <div class="data-group">
                            <div class="group">
                                <label class="title"><span [innerHTML]="'personalData.city' | translate"></span>:</label>
                                <label class="text">{{ user.city }}</label>
                            </div>
                        </div>

                        <div class="data-group">
                            <div class="group">
                                <label class="title"><span [innerHTML]="'personalData.zipCode' | translate"></span>:</label>
                                <label class="text">{{ user.zipCode }}</label>
                            </div>
                        </div>
                        <div *ngIf="user.regionKey" class="data-group">
                            <div class="group">
                                <label class="title"><span [innerHTML]="'personalData.region' | translate"></span>:</label>
                                <label class="text">{{ user.regionKey}}</label>
                            </div>
                        </div>
                        <div class="data-group">
                            <div class="group">
                                <label class="title"><span [innerHTML]="'personalData.country' | translate"></span>:</label>
                                <label class="text">{{ user.country.name}}</label>
                            </div>
                        </div>
                    </div>

                    <div class="bottom">
                        <div class="data-group full-width subscribe">
                            <div class="group">
                                <label class="title" [innerHTML]="'personalData.subscribe' | translate"></label>
                                <label class="text" *ngIf="user.subscribe" [innerHTML]="'personalData.subscribeYes' | translate"></label>
                                <label class="text" *ngIf="!user.subscribe" [innerHTML]="'personalData.subscribeNo' | translate"></label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group button-wrapper">
                        <a
                            *ngIf="showBackButton"
                            (click)="goBack()"
                            class="button secondary"
                            [routerLink]="linkBookingSteps"
                            [queryParams]="{ bookingPerson: true }"
                            [innerHTML]="'personalData.cancel' | translate"
                        ></a>
                        <a da-link class="button primary" (click)="edit()" [innerHTML]="'personalData.edit' | translate"></a>
                    </div>
                </div>
            </div>
            <ng-container>
                <ng-container *ngIf="user$ | async as user">
                    <div class="container">
                        <h1 [innerHTML]="'personalData.titleBillingView' | translate"></h1>
                        <p class="large" [innerHTML]="'personalData.introBillingContact' | translate"></p>
                        <div class="personal-data-wrapper">
                            <div class="top">
                                <div class="data-group">
                                    <div class="group">
                                        <label class="title"><span [innerHTML]="'personalData.salutation' | translate"></span>:</label>
                                        <label class="text">{{ user.billingContact.salutation.name }}</label>
                                    </div>
                                </div>

                                <div class="data-group">
                                    <div class="group">
                                        <label class="title"><span [innerHTML]="'personalData.title' | translate"></span>:</label>
                                        <label class="text">{{ user.billingContact.title }}</label>
                                    </div>
                                </div>

                                <div class="data-group">
                                    <div class="group">
                                        <label class="title"><span [innerHTML]="'personalData.name' | translate"></span>:</label>
                                        <label class="text">{{ user.billingContact.firstName }} {{ user.billingContact.lastName }}</label>
                                    </div>
                                </div>

                                <div class="data-group">
                                    <div class="group">
                                        <label class="title"><span [innerHTML]="'personalData.phone' | translate"></span>:</label>
                                        <label class="text">{{ user.billingContact.phoneCountry }}{{ user.billingContact.phoneCity }}{{ user.billingContact.phoneNumber }}</label>
                                    </div>
                                </div>

                                <div class="data-group">
                                    <div class="group">
                                        <label class="title"><span [innerHTML]="'personalData.department' | translate"></span>:</label>
                                        <label class="text">{{ user.billingContact.department }}</label>
                                    </div>
                                </div>
                            </div>

                            <div class="top">
                                <div class="data-group">
                                    <div class="group">
                                        <label class="title"><span [innerHTML]="'personalData.company' | translate"></span>:</label>
                                        <label class="text">{{ user.billingContact.company.name }}</label>
                                    </div>
                                </div>

                                <div class="data-group">
                                    <div class="group">
                                        <label class="title"><span [innerHTML]="'personalData.address' | translate"></span>:</label>
                                        <label class="text">{{ user.billingContact.address }}</label>
                                    </div>
                                </div>

                                <div class="data-group">
                                    <div class="group">
                                        <label class="title"><span [innerHTML]="'personalData.city' | translate"></span>:</label>
                                        <label class="text">{{ user.billingContact.city }}</label>
                                    </div>
                                </div>

                                <div class="data-group">
                                    <div class="group">
                                        <label class="title"><span [innerHTML]="'personalData.zipCode' | translate"></span>:</label>
                                        <label class="text">{{ user.billingContact.zipCode }}</label>
                                    </div>
                                </div>
                                <div *ngIf="user.regionKey" class="data-group">
                                    <div class="group">
                                        <label class="title"><span [innerHTML]="'personalData.region' | translate"></span>:</label>
                                        <label class="text">{{ user.billingContact.regionKey}}</label>
                                    </div>
                                </div>
                                <div class="data-group">
                                    <div class="group">
                                        <label class="title"><span [innerHTML]="'personalData.country' | translate"></span>:</label>
                                        <label class="text">{{ user.billingContact.country.name}}</label>
                                    </div>
                                </div>
                            </div>

                            <div class="bottom">
                                <div class="data-group full-width subscribe">
                                    <div class="group">
                                        <label class="title" [innerHTML]="'personalData.subscribe' | translate"></label>
                                        <label
                                            class="text"
                                            *ngIf="user.subscribe"
                                            [innerHTML]="'personalData.subscribeYes' | translate"
                                        ></label>
                                        <label
                                            class="text"
                                            *ngIf="!user.subscribe"
                                            [innerHTML]="'personalData.subscribeNo' | translate"
                                        ></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </section>
        <section class="background-color-nearwhite">
            <div class="container">
                <p>
                    <span [innerHTML]="'personalData.legalNotice' | translate"></span>
                    <a *ngIf="isPortal" href="/partner/{{portalId$ | async }}/disclaimer" da-link><span [innerHTML]="'personalData.dataProtection' | translate"></span></a>
                    <a *ngIf="!isPortal" href="/dataprotection" da-link><span [innerHTML]="'personalData.dataProtection' | translate"></span></a>
                </p>
                <p>
                    <span [innerHTML]="'personalData.contactUs' | translate"></span>
                    <a href="mailto: {{'personalData.emailAddress' | translate}}" da-link><span [innerHTML]="'personalData.emailAddress' | translate"></span></a>
                </p>
            </div>
        </section>
    </div>

    <div class="edit-mode" [ngClass]="isEditMode ? 'show' : 'hide'">
        <section class="background-color-nearwhite">
            <div class="container">
                <h1 [innerHTML]="'personalData.editTitle' | translate"></h1>
                <p class="large" [innerHTML]="'personalData.editIntro' | translate"></p>

                <form [formGroup]="personalForm">
                    <div class="personal-data-wrapper">
                        <div class="top">
                            <div class="data-group">
                                <div class="group no-bottom-padding">
                                    <div class="group" *ngIf="salutations$ | async as salutations">
                                        <label
                                            for="salutation"
                                            [class.active]="hasFocusSalutation || hasValue(f.salutation)"
                                            [class.hasvalue]="!hasFocusSalutation && hasValue(f.salutation)"
                                        >
                                            <span class="labelcontent"
                                                ><span [innerHTML]="'personalData.salutation' | translate"></span>*</span
                                            >
                                            <div class="select-wrapper">
                                                <select
                                                    formControlName="salutation"
                                                    id="salutation"
                                                    (focus)="hasFocusSalutation = true"
                                                    (blur)="hasFocusSalutation = false"
                                                >
                                                    <option *ngFor="let item of salutations" [value]="item.key">{{ item.value }}</option>
                                                </select>
                                            </div>
                                        </label>

                                        <div *ngIf="submitted && f.salutation.errors" class="invalid-feedback">
                                            <div
                                                *ngIf="f.salutation.errors.required"
                                                [innerHTML]="'personalData.fieldRequired' | translate"
                                            ></div>
                                        </div>
                                    </div>
                                    <div class="group">
                                        <label
                                            for="title"
                                            [class.active]="hasFocusTitle || hasValue(f.title)"
                                            [class.hasvalue]="!hasFocusTitle && hasValue(f.title)"
                                        >
                                            <span class="labelcontent"><span [innerHTML]="'personalData.title' | translate"></span></span>
                                            <input
                                                formControlName="title"
                                                id="title"
                                                (focus)="hasFocusTitle = true"
                                                (blur)="hasFocusTitle = false"
                                                type="text"
                                                maxlength="40"
                                            />
                                        </label>

                                        <div *ngIf="submitted && f.title.errors" class="invalid-feedback">
                                            <div
                                                *ngIf="f.title.errors.required"
                                                [innerHTML]="'personalData.fieldRequired' | translate"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="data-group two-rows company-details full-width">
                                <div class="group">
                                    <label class="title"
                                        ><span [innerHTML]="'personalData.firstName' | translate"></span><span>*</span></label
                                    >
                                    <label class="text">{{ user.firstName }} {{ user.lastName }}</label>
                                </div>
                            </div>
                            <div class="data-group">
                                <div class="group">
                                    <label
                                        for="phone"
                                        [class.active]="hasFocusPhone || hasValue(f.phone)"
                                        [class.hasvalue]="!hasFocusPhone && hasValue(f.phone)"
                                    >
                                        <span class="labelcontent"><span [innerHTML]="'personalData.phone' | translate"></span></span>
                                        <input
                                            formControlName="phone"
                                            id="phone"
                                            (focus)="hasFocusPhone = true"
                                            (blur)="hasFocusPhone = false"
                                            type="text"
                                            maxlength="32"
                                        />
                                    </label>
                                    <div *ngIf="submitted && f.phone.errors" class="invalid-feedback">
                                        <div *ngIf="f.phone.errors.required" [innerHTML]="'personalData.fieldRequired' | translate"></div>
                                    </div>
                                </div>
                                <div class="group">
                                    <label
                                        for="department"
                                        [class.active]="hasFocusDepartment || hasValue(f.department)"
                                        [class.hasvalue]="!hasFocusDepartment && hasValue(f.department)"
                                    >
                                        <span class="labelcontent"><span [innerHTML]="'personalData.department' | translate"></span></span>
                                        <input
                                            formControlName="department"
                                            id="department"
                                            (focus)="hasFocusDepartment = true"
                                            (blur)="hasFocusDepartment = false"
                                            type="text"
                                            maxlength="50"
                                        />
                                    </label>

                                    <div *ngIf="submitted && f.department.errors" class="invalid-feedback">
                                        <div
                                            *ngIf="f.department.errors.required"
                                            [innerHTML]="'personalData.fieldRequired' | translate"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                            <div class="data-group two-rows company-details full-width">
                                <div class="group">
                                    <label class="title"
                                        ><span [innerHTML]="'personalData.company' | translate"></span><span>*</span>:</label
                                    >
                                    <label class="text">{{ user.company.name }}</label>
                                </div>
                                <div class="group">
                                    <label class="title"
                                        ><span [innerHTML]="'personalData.address' | translate"></span><span>*</span>:</label
                                    >
                                    <label class="text">{{ user.address }}</label>
                                </div>
                                <div class="group">
                                    <label class="title"><span [innerHTML]="'personalData.city' | translate"></span><span>*</span>:</label>
                                    <label class="text">{{ user.city }}</label>
                                </div>
                                <div class="group">
                                    <label class="title"
                                        ><span [innerHTML]="'personalData.zipCode' | translate"></span><span>*</span>:</label
                                    >
                                    <label class="text">{{ user.zipCode }}</label>
                                </div>
                                <div *ngIf="user.regionKey" class="data-group">
                                    <div class="group">
                                        <label class="title"><span [innerHTML]="'personalData.region' | translate"></span><span>*</span>:</label>
                                        <label class="text">{{ user.regionKey}}</label>
                                    </div>
                                </div>
                                <div class="group">
                                    <label class="title"
                                        ><span [innerHTML]="'personalData.country' | translate"></span><span>*</span>:</label
                                    >
                                    <label class="text">{{ user.country.name}}</label>
                                </div>
                            </div>
                        </div>

                        <div class="bottom"></div>
                        <div class="data-group full-width subscribe">
                            <div class="group">
                                <p>
                                    <label for="subscribe" id="label-{subscribe" class="checkboxlabel">
                                        <input id="subscribe" type="checkbox" formControlName="subscribe" />
                                        <span class="checkboxlabelvalue">{{ 'personalData.subscribeCheckbox' | translate }}</span>
                                    </label>
                                </p>
                            </div>
                        </div>
                    </div>
                    <span class="required" [innerHTML]="'personalData.required' | translate"></span>
                    <div class="form-group button-wrapper">
                        <a da-link class="button secondary" (click)="cancel()" [innerHTML]="'personalData.cancel' | translate"></a>
                        <button type="submit" class="button primary" (click)="onSubmit()">
                            <span [innerHTML]="'personalData.save' | translate"></span>
                        </button>
                    </div>
                    <div *ngIf="showError" class="error-message" [innerHTML]="'personalData.errorMessage' | translate"></div>
                </form>
            </div>
        </section>
    </div>
</div>
